import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface User {
  username: string;
  name?: string;
  given_name?: string;
  family_name?: string;
  phone_number?: string;
  email?: string;
  profile?: string;
  dob?: string;
  gender?: string;
  preferred_username?: string;
}

export interface Token {
  accessToken: string;
  refreshToken: string;
}

export interface AuthState {
  Auth: {
    user: User | null;
    accessToken: string | null;
    refreshToken: string | null;
    isAuthenticated: boolean;
  };
}

const initialState: AuthState = {
  Auth: {
    user: null,
    accessToken: null,
    refreshToken: null,
    isAuthenticated: false,
  },
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserData: (
      state,
      action: PayloadAction<{
        user: User;
        token: Token;
      }>
    ) => {
      state.Auth.user = action.payload.user;
      state.Auth.accessToken = action.payload.token.accessToken;
      state.Auth.refreshToken = action.payload.token.refreshToken;
      state.Auth.isAuthenticated = true;
    },
    updateAccessToken: (state, action: PayloadAction<string>) => {
      state.Auth.accessToken = action.payload;
    },
    clearTokens: (state) => {
      state.Auth.accessToken = null;
      state.Auth.refreshToken = null;
      state.Auth.user = null;
      state.Auth.isAuthenticated = false;
    },
    logout: (state) => {
      state.Auth.user = null;
      state.Auth.accessToken = null;
      state.Auth.refreshToken = null;
      state.Auth.isAuthenticated = false;
    },
  },
});

export const { setUserData, updateAccessToken, clearTokens, logout } = authSlice.actions;
export default authSlice.reducer;
